import { Badge, type MantineColor } from '@mantine/core';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { FiCheckCircle, FiClock, FiLock, FiMail, FiPauseCircle, FiSlash, FiXCircle } from 'react-icons/fi';

const STYLES: Record<string, { color: MantineColor; icon: ReactNode }> = {
  active: { color: 'green', icon: <FiCheckCircle size={12} /> },
  accepted: { color: 'green', icon: <FiCheckCircle size={12} /> },
  invited: { color: 'blue', icon: <FiMail size={12} /> },
  pending: { color: 'blue', icon: <FiClock size={12} /> },
  suspended: { color: 'orange', icon: <FiPauseCircle size={12} /> },
  locked: { color: 'orange', icon: <FiLock size={12} /> },
  expired: { color: 'gray', icon: <FiClock size={12} /> },
  revoked: { color: 'gray', icon: <FiSlash size={12} /> },
  disabled: { color: 'red', icon: <FiXCircle size={12} /> },
  deleted: { color: 'red', icon: <FiXCircle size={12} /> },
};

/** Status chip: always an icon and a word, never colour alone (doc 09 §1). */
export function StatusBadge({ status }: { status: string }) {
  const { t } = useTranslation();
  const style = STYLES[status] ?? { color: 'gray', icon: null };
  return (
    <Badge color={style.color} leftSection={style.icon}>
      {t(`status.${status}`, status)}
    </Badge>
  );
}

const ROLE_COLORS: Record<string, MantineColor> = {
  org_admin: 'brand',
  editor: 'teal',
  viewer: 'gray',
  client: 'grape',
  platform_admin: 'brand',
  platform_support: 'cyan',
};

export function RoleBadge({ role }: { role: string }) {
  const { t } = useTranslation();
  return (
    <Badge color={ROLE_COLORS[role] ?? 'gray'} variant="light">
      {t(`roles.${role}`, role)}
    </Badge>
  );
}
